const STORAGE_KEY = 'food_trainer_ref'

export function normalizeTrainerCode(raw?: string | null): string | null {
  const s = String(raw || '').trim().toUpperCase()
  if (!/^TRN-[A-Z0-9]{4,12}$/.test(s)) return null
  return s
}

export function persistTrainerRef(code: string | null) {
  try {
    if (!code) {
      sessionStorage.removeItem(STORAGE_KEY)
      localStorage.removeItem(STORAGE_KEY)
      return
    }
    sessionStorage.setItem(STORAGE_KEY, code)
    localStorage.setItem(STORAGE_KEY, code)
  } catch { /* noop */ }
}

export function captureTrainerRefFromSearch(search: string): string | null {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
  const fromUrl = normalizeTrainerCode(params.get('ref') || params.get('trainer') || params.get('code'))
  if (fromUrl) persistTrainerRef(fromUrl)
  return fromUrl
}

export function foodTrainerRegisterUrl(code: string): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  const ref = normalizeTrainerCode(code)
  return `${origin}/register?ref=${encodeURIComponent(ref || '')}`
}
